<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path
    d="M12.0998 11.5001C15.1998 11.5001 17.7998 9.00007 17.7998 5.80007C17.7998 2.70007 15.2998 0.100066 
    12.0998 0.100066C8.8998 6.62431e-05 6.2998 2.50007 6.2998 5.70007C6.2998 8.90007 8.8998 11.5001 12.0998 11.5001Z"
    fill="#748097"
  />
  <path
    d="M29.8 17.1V30H16.8V17.1H29.8ZM29.8 15.2H16.8C15.8 15.2 15 16 15 17V30C15 31 15.8 31.7999 16.8 31.7999H29.7C30.7 
    31.7999 31.5 31 31.5 30V17.1C31.6 16.1 30.8 15.2 29.8 15.2Z"
    fill="#009DD6"
  />
  <path
    d="M25.1001 28.1H18.6001V26.3H25.1001V28.1ZM27.9001 24.5H18.7001V22.7H27.9001V24.5ZM27.9001 20.8H18.7001V19H27.9001V20.8Z"
    fill="#009DD6"
  />
  <path
    d="M13.3 15.9C13.3 14.8 14.1 14 15 13.7H7.7C3.9 13.7 1 16.7 1 20.4V23C1 23.6 1.4 24 2 24H13.3V15.9Z"
    fill="#748097"
  />
</svg>
